export type PromoCodeType = {
  code: string;
  amount: number;
  type: string;
  usageLimit: number;
  isActive: boolean;
  expiryDate: any;
  source?: string;
  partnerName?: string;
  // Optional scope: restrict the code to a diploma, or one batch of it. Empty
  // ⇒ global. `batchId` requires `diploma`. See PromoNewEditForm.
  diploma?: string | null;
  batchId?: string | null;
  _id?: string;
  usageCount?: number;
};

// Promo-code sources offered in the admin UI + the source filter.
export const PROMO_SOURCES = ['admin', 'partner'];
